"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const RecommendationsActionsPanel_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Recommendations/components/RecommendationsActionsPanel.vue"));
const RecommendationsNotRetrieved_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Recommendations/components/RecommendationsNotRetrieved.vue"));
const Recommendation_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Recommendations/components/Recommendation.vue"));
let MapTooltipRecommendationSection = class MapTooltipRecommendationSection extends vue_property_decorator_1.Vue {
    get sortedProducts() {
        var _a;
        // Ordena los productos de mayor a menor según el 'level'
        return (_a = this.recommendation) === null || _a === void 0 ? void 0 : _a.products.sort((a, b) => b.level - a.level);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapTooltipRecommendationSection.prototype, "recommendation", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapTooltipRecommendationSection.prototype, "project", void 0);
MapTooltipRecommendationSection = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            Tag: bmk_ui_framework_1.Tag,
            RecommendationsActionsPanel: RecommendationsActionsPanel_vue_1.default,
            RecommendationsNotRetrieved: RecommendationsNotRetrieved_vue_1.default,
            RecommendationComponent: Recommendation_vue_1.default
        },
    })
], MapTooltipRecommendationSection);
exports.default = MapTooltipRecommendationSection;
